<template>
  <a href="https://www.byggbranschensyrkesnamnd.se/" target="_blank" class="logo">
    <v-icon size="100">$sl-logo</v-icon> 
  </a>
</template>

<script>
export default {
  name: 'AppLogoButton'
}
</script>